import { listAll, ref } from 'firebase/storage';
import { storage } from '@/firebase';

export const getPartnersImages = async () => {
  const partnersImagesRef = ref(storage, 'images/partners');

  const imagesResponse = await listAll(partnersImagesRef);

  if (!imagesResponse.items.length) {
    return [];
  }

  return imagesResponse.items.map(image => `https://firebasestorage.googleapis.com/v0/b/${image.bucket}/o/${encodeURIComponent(image.fullPath)}?alt=media`);
};